import axiosInstance from '../axiosInstance';
import { URL } from '../config/constants';

class WeeklyRosterService {
    // Get roster for a specific week
    async getRoster(weekYear) {
        try {
            const response = await axiosInstance.get(`${URL}/weekly-roster/${weekYear}`);
            return response.data;
        } catch (error) {
            if (error.response?.status === 404) {
                return null;
            }
            throw error;
        }
    }

    // Save or update roster
    async saveRoster(rosterData) {
        try {
            const response = await axiosInstance.post(`${URL}/weekly-roster`, rosterData);
            return response.data;
        } catch (error) {
            console.error('Error saving roster:', error);
            throw error;
        }
    }

    // Get rosters for the last N weeks
    async getLastWeeks(weeks = 10) {
        try {
            const response = await axiosInstance.get(`${URL}/weekly-roster/last/${weeks}`);
            return response.data;
        } catch (error) {
            console.error('Error getting last weeks:', error);
            throw error;
        }
    }

    // Delete roster for a specific week
    async deleteRoster(weekYear) {
        try {
            const response = await axiosInstance.delete(`${URL}/weekly-roster/${weekYear}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting roster:', error);
            throw error;
        }
    }

    // Get rosters between dates
    async getRosterRange(startDate, endDate) {
        try {
            const response = await axiosInstance.post(`${URL}/weekly-roster/range`, {
                startDate,
                endDate
            });
            return response.data;
        } catch (error) {
            console.error('Error getting roster range:', error);
            throw error;
        }
    }

    // Sync local rosters with server
    async syncWithServer(localRosters) {
        const results = {
            synced: [],
            errors: []
        };

        for (const roster of localRosters) {
            try {
                const saved = await this.saveRoster(roster);
                results.synced.push(saved);
            } catch (error) {
                results.errors.push({
                    roster,
                    error: error.message
                });
            }
        }

        return results;
    }
}

export default new WeeklyRosterService();